export const ON_PROCESS_STATES = [ 'draft', 'ready_for_negotiation', 'negotiated' ]
export const ON_PROCESS_FILTER = ON_PROCESS_STATES.join(',')

export const normalizeSettlementStatusFilter = (value = '') => (
  ON_PROCESS_STATES.includes(value) ? ON_PROCESS_FILTER : value
)

export const settlementStatusOptions = (states, labelForState) => {
  const options = []
  states.forEach((state) => {
    const value = normalizeSettlementStatusFilter(state)
    if (!options.some((option) => option.value === value)) {
      options.push({ value, label: value === ON_PROCESS_FILTER ? 'On Process' : labelForState(state) })
    }
  })
  return options
}
